module.exports = __webpack_public_path__ + "media/images/lp_voice-3-09e240da78b049119a86f9cee5bc8435.webp";